import { Component, OnDestroy, OnInit } from '@angular/core';
import * as pbi from 'powerbi-client';
import { Report } from 'report';
import { EmbedInfoService } from 'src/shared/service-proxies/service-proxies';
import { PageHelperService } from '../helpers/page-helper.service';
import { PagebaseComponent } from '../pagebase/pagebase.component';
import { ApplicationStatusService } from '../services/application-status.service';
import { CustomerSettings } from '../services/customer-settings-service';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss'],
    standalone: false
})
export class ReportsComponent extends PagebaseComponent implements OnInit, OnDestroy {
  // Public variables
  loading: boolean = true;
  companyId: string = "";
  powerbi: pbi.service.Service;
  reportsContainer: HTMLElement;
  outputReportNames: boolean = false;

  constructor(private _embedInfoService: EmbedInfoService, pageHelperService: PageHelperService, applicationStatusService: ApplicationStatusService, private customerSettings: CustomerSettings) {
    super(pageHelperService, applicationStatusService, customerSettings, "Reports");
  }

  ngOnInit() {
  }
   
  
  ngOnDestroy(): void {
    this.reset();
  }

  getData() {
    this.loading = true;
    this.setIsLoading(this.loading);
    this._embedInfoService.getEmbedInfo(this.pageHelperService.selectedCompanyId, window.location.pathname).subscribe(data => {
      const config = {
        type: 'report',
        tokenType: 1,
        embedUrl: data.embedReport[0].embedUrl + '&language=en&formatLocale=en-GB',
        accessToken: data.embedToken.token,
        pageName: this.getReportPageName(),
        settings: {
          filterPaneEnabled: false,
          navContentPaneEnabled: false,
          background: 1,
        }
      };
      // Grab the reference to the div HTML element that will host the report.
      this.reportsContainer = <HTMLElement>document.getElementById(
        'reportsContainer'
      );

      // Embed the report and display it within the div container.
      this.powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      this.powerbi.reset(this.reportsContainer);
      const report: Report = <Report>(this.powerbi.embed(
        this.reportsContainer,
        config
      ));

      var outputReportNames = this.outputReportNames;
      // Report.off removes a given event handler if it exists.
      report.off('loaded');
      // Report.on will add an event handler which prints to Log window.
      report.on('loaded', function () {
        console.log('Loaded, outputReportNames=' + outputReportNames);
        if (outputReportNames) {
          report.getPages().then(function (pages) {
            console.log('report loaded, number of pages: ', pages.length);
            pages.forEach(function(page) {
              var log = page.name + " - " + page.displayName;
              console.log(log);
            });
            // We only want to handle the 'loaded' event once
            report.off('loaded');
          });
        }
      });

      report.off('pageChanged');
      report.on('pageChanged', e => {
        console.log(e);
      });

      report.on('error', function (event) {
        console.log(event.detail);
        report.off('error');
      });
      this.loading = false;
      this.setIsLoading(this.loading);
    }, error => {
      console.error(error)
      debugger;
    });
  }

  getReportPageName() {
    switch (window.location.pathname) {
      case "/container-register":
        return ("ReportSection")
      case "/service-frequency":
        return ("ReportSection5003968c8c0c943a47be")
      case "/damage-report":
        return ("ReportSection0d22722be00daee2d75b")
        case "/damage-history-report":
          return ("c059a3c1d53744f1ff46")        
        case "/report-builder":
          return ("ReportSectionfa2dc67d82ef347a4e21")
      default:
        return ("")
    }
  }

  reset(): void {
    if (this.powerbi) {
      this.powerbi.reset(this.reportsContainer);
    }
  }
}
